import styled from "styled-components";

const CONTENT_PADDING_RIGHT = 36;

export const Container = styled.div`
    overflow: hidden;
    padding: ${(props) => props.theme.spacing.medium} ${(props) => props.theme.spacing.medium} 0
        ${(props) => props.theme.spacing.medium};
`;

export const PaymentMethodContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
`;

export const DisplayNameContainer = styled.div`
    display: flex;
`;

export const PrimaryContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - ${CONTENT_PADDING_RIGHT}px);
`;

export const PaymentMethodSlideButtonContainer = styled.div`
    margin-left: 0;
    margin-top: 16px;
`;

export const DynamicPromoSubText = styled.div`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const KfsDisclaimerContainerV1 = styled.div`
    padding: ${(props) => props.theme.spacing.small} 0 0 0;
    text-align: center;
`;

export const KfsLinkV1 = styled.span`
    text-decoration: underline;
    cursor: pointer;
`;
